webpackJsonpUpdateBris([86],{

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PromoHeroCarousel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'PromoHeroCarousel';
var CLS = 'promoHeroCarousel';
var BLK = '.' + CLS + '-';
var SLIDE_TO_SHOW = 1;
var SPEED_TIME_TRANSITION = 1000;
var DELAY_TIME_TRANSITION = 3000;
var CLS_IS_INITED = 'is-initialized';
var CLS_DISABLED = 'disabled';

var PromoHeroCarousel = exports.PromoHeroCarousel = function () {
	function PromoHeroCarousel(el) {
		_classCallCheck(this, PromoHeroCarousel);

		this.el = el;
		this.$el = $(el);
		this.$slider = this.$el.find('.' + CLS + '-slider');
		this.$sliderWrap = this.$el.find('.' + CLS + '-sliderWrap');
		this.$btnNext = this.$el.find('.' + CLS + '-btnNext');
		this.$btnPrev = this.$el.find('.' + CLS + '-btnPrev');
		this.$slidePagination = this.$el.find('.' + CLS + '-pagination');

		this.delayTimeTransition = this.$el.data('delayTimeTransition');
		if (this.delayTimeTransition && !isNaN(this.delayTimeTransition)) {
			this.delayTimeTransition = parseInt(this.delayTimeTransition);
		} else {
			this.delayTimeTransition = DELAY_TIME_TRANSITION;
		}

		this.speedTimeTransition = this.$el.data('speedTimeTransition');
		if (this.speedTimeTransition && !isNaN(this.speedTimeTransition)) {
			this.speedTimeTransition = parseInt(this.speedTimeTransition);
		} else {
			this.speedTimeTransition = SPEED_TIME_TRANSITION;
		}

		this.initPromoSwiper();
	}

	_createClass(PromoHeroCarousel, [{
		key: 'initPromoSwiper',
		value: function initPromoSwiper() {
			var _this = this;

			var promoSwiper = new Swiper(this.$sliderWrap[0], {
				init: false,
				slidesPerView: SLIDE_TO_SHOW,
				mousewheel: false,
				lazy: true,
				autoplay: {
					delay: this.delayTimeTransition,
					disableOnInteraction: false
				},
				speed: this.speedTimeTransition,
				loop: true,
				keyboard: {
					enabled: true
				},
				pagination: {
					el: this.$slidePagination[0],
					clickable: true
				},
				navigation: {
					nextEl: this.$btnNext[0],
					prevEl: this.$btnPrev[0]
				}
			});

			promoSwiper.on('init', function () {
				_this.$el.addClass(CLS_IS_INITED);
			});

			if (this.$slider.find('.' + CLS + '-item').length <= 1) {
				this.$sliderWrap.addClass(CLS_DISABLED);
				this.$slidePagination.addClass(CLS_DISABLED);
			} else {
				promoSwiper.init();
			}
		}
	}]);

	return PromoHeroCarousel;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1754042353042.blk-promo-hero-carousel-chunk.js